import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Browser } from '@capacitor/browser';
import { Platform } from '@ionic/angular/standalone';

@Injectable({
    providedIn: 'root'
})
export class PaymentBrowserService {
    private _browserOpen = new BehaviorSubject<boolean>(false);
    browserOpen$ = this._browserOpen.asObservable();

    private _returnedViaDeepLink = false;

    private _onBrowserCancelledCallback: (() => void) | null = null;

    private browserFinishedListener: any = null;

    constructor(
        private platform: Platform,
        private zone: NgZone
    ) {}

    async openPaymentBrowser(url: string, onCancelled?: () => void): Promise<void> {
        this._returnedViaDeepLink = false;
        this._onBrowserCancelledCallback = onCancelled || null;
        this._browserOpen.next(true);

        if (this.platform.is('capacitor')) {
            this.browserFinishedListener = await Browser.addListener('browserFinished', () => {
                this.zone.run(() => {
                    this.handleBrowserFinished();
                });
            });
        }

        await Browser.open({
            url,
            presentationStyle: 'fullscreen'
        });
    }

    async handleDeepLinkReturn(): Promise<void> {
        this._returnedViaDeepLink = true;
        await this.closeBrowser();
    }

    async closeBrowser(): Promise<void> {
        try {
            await Browser.close();
        } catch (error) {
            console.log('Browser already closed or error closing:', error);
        }

        this.cleanup();
    }

    isBrowserOpen(): boolean {
        return this._browserOpen.getValue();
    }

    wasReturnViaDeepLink(): boolean {
        return this._returnedViaDeepLink;
    }

    private handleBrowserFinished(): void {
        if (!this._returnedViaDeepLink && this._onBrowserCancelledCallback) {
            console.log('Browser closed manually - user cancelled payment');
            this._onBrowserCancelledCallback();
        }

        this.cleanup();
    }

    private cleanup(): void {
        this._browserOpen.next(false);
        this._onBrowserCancelledCallback = null;

        if (this.browserFinishedListener) {
            this.browserFinishedListener.remove();
            this.browserFinishedListener = null;
        }
    }
}
